/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getChatMessages} from '../api'

 export const useQueryGetChatMessages = createReactQueryHook('getChatMessages', getChatMessages)
